import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex items-center justify-between px-6 md:px-10 h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <span className={`font-heading text-xl md:text-2xl font-black tracking-tight transition-colors duration-300 ${scrolled ? 'text-primary-700' : 'text-white'}`}>
            51吃瓜网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              location.pathname === '/'
                ? scrolled
                  ? 'bg-primary-100 text-primary-700'
                  : 'bg-white/20 text-white'
                : scrolled
                  ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? scrolled
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : scrolled
                    ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              location.pathname === '/about'
                ? scrolled
                  ? 'bg-primary-100 text-primary-700'
                  : 'bg-white/20 text-white'
                : scrolled
                  ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
            scrolled ? 'text-foreground-800 hover:bg-background-100' : 'text-white hover:bg-white/10'
          }`}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-6 py-4 flex flex-col gap-1">
          <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 whitespace-nowrap">首页</Link>
          {categories.map((cat) => (
            <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 whitespace-nowrap">{cat.name}</Link>
          ))}
          <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 whitespace-nowrap">关于我们</Link>
        </div>
      )}
    </nav>
  );
}